<template>
  <v-overlay
    :value="visible"
    z-index="2000"
  >
    <v-progress-circular
      indeterminate
      size="64"
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  computed: {
    visible() {
      return this.$store.state.overlay.visible;
    },
  },
};
</script>
